export const isArray = function (a) {
	return Array.isArray(a);
};
